import React from 'react';
import './OurApproachAbout.css';
import { FaRegHandshake, FaCogs, FaShieldAlt, FaTools } from "react-icons/fa";
export default function OurApproachAbout() {
  return (
    <>
     <section className="our-approach-section">
      <div className="container">
        <h2 className="section-heading">Our Approach</h2>
        <p className="section-description">
          At SARS India Liaison Pvt Ltd, we believe in delivering customized solutions that meet the unique needs of every client. Our approach is focused on precision, professionalism, and partnership.
        </p>
        <div className="approach-cards">
          <div className="card">
            <div className="icon">
              <FaRegHandshake />
            </div>
            <h3>Tailored Solutions</h3>
            <p>
              We collaborate closely with our clients to understand their specific requirements and deliver solutions that fit their goals and challenges.
            </p>
          </div>
          <div className="card">
            <div className="icon">
              <FaCogs />
            </div>
            <h3>Compliance Management</h3>
            <p>
              Our expertise ensures seamless compliance audits and adherence to regulatory requirements with minimal hassle for our clients.
            </p>
          </div>
          <div className="card">
            <div className="icon">
              <FaShieldAlt />
            </div>
            <h3>End-to-End Support</h3>
            <p>
              From initial consultations to securing approvals, we provide comprehensive support at every step of the process.
            </p>
          </div>
          <div className="card">
            <div className="icon">
              <FaTools />
            </div>
            <h3>Modern Tools</h3>
            <p>
              We leverage advanced tools and technology for efficient tracking and management of statutory compliance.
            </p>
          </div>
        </div>
      </div>
    </section>
    
    
    
    
    
    
    </>
  )
}
